import { Component } from '@angular/core';

@Component({
  selector: 'app-login-error-page',
  standalone: true,
  imports: [],
  templateUrl: './login.error.page.html',
})
export class LoginErrorPage {
  _common=_common;
  constructor() {}
  ngOnInit() {}
}
